<template>
  <el-menu
    router
    unique-opened
    :default-active="active"
    text-color="--font-color"
    active-text-color="--font-color"
  >
    <template v-for="(item,index) in menus">
      <el-menu-item
        :index="item.url"
        :key="'e' + index"
        class="menu1"
      >
        <span class="iconfont" :class="item.iconPath"></span>
        <span slot="title">{{ item.menuName }}</span>
      </el-menu-item>
      <div v-if="active === item.url" class="right-content" :key="index">
        <router-view name="right"/>
      </div>
    </template>
  </el-menu>
</template>

<script>
export default {
  name: 'RightBlock',
  props: {},
  data () {
    return {}
  },
  computed: {
    menus () {
      return this.$store.getters.rightMenuList
    },
    active () {
      const path = this.$route.path.split('/')
      return '/' + path[1]
    }
  },
  watch: {
  },
  created () {
    // do something
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  .el-menu {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 13px;
    background: transparent !important;
    border-right: 0 !important;
    .iconfont {
      font-size: 16px;
      margin-right: 6px;
      &:before {
        /* 为了兼容不支持 background-clip: text 的浏览器 */
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        background-image: linear-gradient(62deg, #0DCCFF, #4760FF);
      }
    }
    ::v-deep {
      .el-submenu__title, .el-menu-item {
        height: 40px;
        line-height: 40px;
        color: var(--font-color) !important;
        padding-left: 5px !important;
        background: linear-gradient(180deg, #FFFFFF, #F4F4F4, #CDD5DE) !important;
      }
    }
    .right-content {
      background: #ffffff;
      border-bottom: 1px solid #f5f5f5 !important;
    }
  }
</style>
